import { useAppSelector } from "store/hooks";

interface StatusBarBackgroundProps {
  backgroundColor?: string;
}

export const StatusBarBackground: React.FC<StatusBarBackgroundProps> = ({
  backgroundColor,
}) => {
  const statusBarHeight = useAppSelector(
    (state) => state?.info?.statusBarHeight
  );
  return (
    <div
      style={{
        height: `${statusBarHeight}px`,
        background: !!backgroundColor
          ? backgroundColor
          : "#0D0D0D",
      }}
      className={`w-screen fixed top-0 z-50`}
    />
  );
};
